<template>
  <div
    class="crypto-academy"
    :style="{ 'background-color': bgColor }"
    :class="{
      'with-circle-corners': withCircleCorners,
      [bgColorClass]: bgColorClass && !bgColor,
    }"
  >
    <div
      :class="[bgContainerClass, { 'container-wrapper': withCircleCorners }]"
    >
      <div class="crypto-academy__container container-new">
        <div
          class="crypto-academy__title txt txt--36px txt--44px--m txt--height-44px txt--height-58px--m txt--color-04 txt--bold"
        >
          {{ $t('tokenNew.cryptoCampus.title') }}
        </div>

        <div class="crypto-academy__info">
          <span
            class="txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-03"
            v-html="$t('tokenNew.cryptoCampus.text')"
          />

          <!-- <label-soon class="mt-24 mt-32--m"> -->
          <button-with-arrow
            :to="localePath('/crypto-campus')"
            size="l"
            class="crypto-academy__button mt-24 mt-32--m"
          >
            {{ $t('welcome.cryptoAcademy.readMoreBtn') }}
          </button-with-arrow>
          <!-- </label-soon> -->
          <!-- <exc-button
            class="crypto-academy__button mt-24 mt-32--m"
            soon
            color="dark"
            size="l"
          /> -->
        </div>

        <div class="crypto-academy__image">
          <div class="crypto-academy__video-block">
            <!-- <iframe
              width="74%"
              height="86%"
              :src="require('@/assets/img/token/gifs/crypto-academy.mp4')"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen="true"
              class="crypto-academy__video"
            /> -->
            <video
              loop
              autoplay
              muted
              playsinline
              loading="lazy"
              class="crypto-academy__video"
            >
              <source
                :src="require('@/assets/img/token/gifs/crypto-academy.mp4')"
                type="video/mp4"
              >
              Your browser does not support the video tag.
            </video>
          </div>
          <!-- <img
            :src="require('@/assets/img/welcome/academy-without-screen.png')"
          > -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { ExcButton } from '@/components/common'

export default {
  components: {
    // ExcButton,
    // LabelSoon: () => import('@/components/ui-kit/labels/LabelSoon.vue'),
    ButtonWithArrow: () =>
      import('@/components/welcome/elements/ButtonWithArrow.vue'),
  },
  props: {
    withCircleCorners: { type: Boolean, default: false },
    bgColorClass: { type: String, default: 'bg--color-02' },
    bgColor: { type: String, default: null },
    bgContainerClass: { type: String, default: 'bg--color-01' },
  },
  computed: {
    isMobile () {
      return this.$mq?.resize && this.$mq?.below(768)
    },
  },
}
</script>

<style lang="scss" scoped>
.crypto-academy {
  &.with-circle-corners &__wrapper {
    padding: toRem(20px) 0;
    border-radius: toRem(20px);
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;

    @include bp(l) {
      padding: toRem(60px) 0;
      border-radius: toRem(60px);
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  &__container {
    display: grid;
    gap: toRem(24px);
    grid-template-areas:
      'title'
      'image'
      'info';

    @include bp(m) {
      grid-template-columns: 1fr 1fr;
      align-items: center;
      gap: toRem(24px) toRem(48px);
      grid-template-areas:
        'image title'
        'image info';
    }

    @include bp(l) {
      gap: toRem(24px) toRem(64px);
    }
  }

  &__title {
    grid-area: title;

    @include bp(m) {
      align-self: flex-end;
    }
  }

  &__info {
    grid-area: info;

    @include bp(m) {
      align-self: flex-start;
    }
  }

  &__image {
    grid-area: image;

    img {
      width: 100%;
    }

    @include bp(0px, m) {
      text-align: center;

      img {
        max-width: toRem(380px);
      }
    }
  }

  &__video-block {
    width: 100%;
    position: relative;
    background: url('@/assets/img/welcome/academy-without-screen.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    // display: flex;
    // justify-content: center;
    // height: toRem(384px);
    height: 220px;

    @include bp(0px, m) {
      margin: 0 auto;
      background-position: top;
      // padding-top: toRem(15px);
      max-width: toRem(380px);
      max-height: toRem(220px);
    }

    @include bp(m) {
      padding-top: 0;
      display: flex;
      height: 300px;
    }
  }

  &__video {
    // width: 80%;
    // height: 86%;

    // width: 75%;
    // height: 86%;
    // height: 75%;

    // height: toRem(190px);
    margin-top: toRem(15px);
    max-width: 72%;

    @include bp(m) {
      // width: 32vw;
      // height: 20vw;
      margin: auto;
      height: 82%;
      // max-height: unset;
      // max-width: unset;
    }

    // @include bp(1400px) {
    //   width: toRem(446px);
    //   height: toRem(279px);
    // }
  }

  &__button {
    @include bp(m) {
      max-width: fit-content;
    }
  }
}
</style>
